"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
const ChallengeStatus_1 = require("../enums/ChallengeStatus");
const ProgressBar_vue_1 = tslib_1.__importDefault(require("./ProgressBar.vue"));
const vuex_1 = require("vuex");
const userTelemetry_1 = require("../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'slide-header-with-nav',
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    data() {
        return {
            contentToggle: false,
            displayErrorMessage: false,
            // suppressed challenge status messaging is typically handled by their specific components
            suppressedChallengeStatus: [
                ChallengeStatus_1.ChallengeStatus.InvalidOneTimeCode,
                ChallengeStatus_1.ChallengeStatus.PdfCodeInvalid,
                ChallengeStatus_1.ChallengeStatus.SyncError,
                ChallengeStatus_1.ChallengeStatus.OTPExpired,
            ],
        };
    },
    props: {
        url: {
            type: String,
            default: '/',
        },
        workflowName: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...(0, vuex_1.mapGetters)(['hasSessionExpiredError', 'hasInvalidChallengeStatus', 'hasServerError', 'currentChallengeType',
            'isForgotPasswordWorkflow', 'isForgotUsernameWorkflow', 'isRegistering']),
        ...(0, vuex_1.mapState)(['challengeStatus', 'currentChallenge', 'isCypress']),
        isMobile() {
            return this.$store.getters.isMobile;
        },
        errorMessage() {
            var _a;
            let errorMessage = '';
            if (this.hasSessionExpiredError) {
                errorMessage = this.getSiteText('ChallengeStatus.SessionExpired');
            }
            else if (!this.suppressedChallengeStatus.includes(this.challengeStatus)) {
                if (this.hasInvalidChallengeStatus) {
                    let siteTextKey = `ChallengeStatus.${this.challengeStatus}`;
                    if (this.workflowName.length > 0)
                        siteTextKey = `${this.workflowName}.${siteTextKey}`;
                    errorMessage = this.getSiteText(siteTextKey, (_a = this.currentChallenge.SessionInfo) === null || _a === void 0 ? void 0 : _a.Id);
                }
                else if (this.hasServerError) {
                    errorMessage = this.getSiteText('Error.Generic');
                }
            }
            this.setDisplayError(errorMessage.length > 0);
            return errorMessage;
        },
        closeButtonText() {
            if (this.isForgotPasswordWorkflow)
                return this.getSiteText('ForgotPassword.Close.Text');
            else if (this.isForgotUsernameWorkflow)
                return this.getSiteText('ForgotUsername.Close.Text');
            else if (this.isRegistering)
                return this.getSiteText('Registration.Close.Text');
            return 'Cancel';
        },
    },
    methods: {
        toggleSheet(toggleOption, event) {
            this.contentToggle = toggleOption;
            if (event) {
                event.preventDefault();
            }
        },
        cancelConfirmText() {
            if (this.$store.getters.isForgotPasswordWorkflow)
                return this.getSiteText('ForgotPassword.Close.Confirm.Text');
            else if (this.$store.getters.isForgotUsernameWorkflow)
                return this.getSiteText('ForgotUsername.Close.Confirm.Text');
            else if (this.$store.getters.isRegistering)
                return this.getSiteText('Registration.Close.Confirm.Text');
            return '';
        },
        setDisplayError(option) {
            this.$nextTick(() => {
                this.displayErrorMessage = option;
                if (option) {
                    this.$refs.slide.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },
        closeNotification() {
            this.displayErrorMessage = false;
        },
        clickCloseButton(event) {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: (0, userTelemetry_1.getStepName)(workflow, this.currentChallengeType),
                    action: userTelemetry_1.userAction.cancel_clicked,
                });
            }
            this.toggleSheet(true, event);
        },
        async clickConfirmClose() {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                await userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.cancellation,
                    stepName: userTelemetry_1.stepName.quit_confirmation,
                    action: userTelemetry_1.userAction.yes_clicked,
                });
            }
            if (this.isCypress)
                return;
            document.location.href = this.url;
        },
        clickCancelClose() {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.cancellation,
                    stepName: userTelemetry_1.stepName.quit_confirmation,
                    action: userTelemetry_1.userAction.cancel_clicked,
                });
            }
            this.toggleSheet(false);
        },
        sheetClosed() {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.cancellation,
                    stepName: userTelemetry_1.stepName.quit_confirmation,
                    action: userTelemetry_1.userAction.sheet_closed,
                });
            }
        },
    },
    mounted() {
        var _a, _b, _c;
        // The following are workarounds for button elements in iris components not having a type set, thus acting as submit buttons
        // The red x to exit the flow
        (_a = document.querySelector('#closeButton button')) === null || _a === void 0 ? void 0 : _a.setAttribute('type', 'button');
        // The button to close notifications
        (_b = document.querySelector('[aria-label="Close notification"]')) === null || _b === void 0 ? void 0 : _b.setAttribute('type', 'button');
        // The hidden close button in the side sheet
        (_c = document.querySelector('[aria-label="navigation menu"]')) === null || _c === void 0 ? void 0 : _c.setAttribute('type', 'button');
        if (this.$store.getters.hasSessionExpiredError) {
            this.setDisplayError(true);
        }
    },
    components: {
        ProgressBar: ProgressBar_vue_1.default,
    },
});
